<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">
                    Edit User
                </div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="changeProfile">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--First Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="firstName">First Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="firstName" type="text" class="form-control" id="firstName" placeholder="First Name" maxlength="190">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.firstName}}</font>
                                </div>
                            </div>
                            <!--Last Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="lastName">Last Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="lastName" type="text" class="form-control" id="lastName" placeholder="Last Name" maxlength="190">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.lastName}}</font>
                                </div>
                            </div>
                            <!--Email-->
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="email">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span v-model="email" class="form-control">{{email}}</span>
                                </div>
                            </div>-->
                            <!--Email-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="email">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="email" type="text" class="form-control" id="email" placeholder="Email" maxlength="190">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.email}}</font>
                                </div>
                            </div>
                            <!--Username-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="username">Day Force Id :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span v-model="username" class="form-control">{{username}}</span>
                                </div>
                            </div>
                            <!--Reporting User-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="username">Reporting To :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="reportTo"
                                                  @change="changedValue"
                                                  @input="changedValueUser()"
                                                  name="reportTo"
                                                  id="reportTo"
                                                  label="text"
                                                  :filterable="false"
                                                  :options="reportToArr"
                                                  @search="onSearchUser"
                                                  placeholder="Select User">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{frontendErrors.reportToError}}</font>
                                </div>
                            </div>
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.locationError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="siteId">Home Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="siteId"
                                              @input="changedValueSite()"
                                              name="siteId"
                                              id="siteId"
                                              label="text"
                                              :options="siteArr"
                                              :searchable="false"
                                              :filterable="false"
                                              placeholder="Select Home Location">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{siteError}}</font>
                                </div>
                            </div>

                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="siteId">Other Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <multiselect v-model="otherSiteId"
                                            :options="siteArr"
                                            :multiple="true" 
                                            :close-on-select="false" 
                                            :clear-on-select="false" 
                                            :preserve-search="true" 
                                            placeholder="Select Other Location"
                                            label="text"
                                            track-by="text" 
                                            :preselect-first="true"
                                            @input="otherSiteError=''"
                                            class="form-control"
                                            >
                                        <template slot="option" slot-scope="props">
                                            <div v-if="appliedStatusFilter.includes(props.option.value)" class="multiple_select_item selected_multiple_item">
                                                <span>{{ props.option.text }}</span>
                                            </div>
                                            <div v-else class="multiple_select_item">
                                                <span>{{ props.option.text }}</span>
                                            </div>
                                        </template>
                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <span class="multiselect__single" v-if="values.length > 1 && !isOpen">{{ values.length }} selected</span>
                                            <span class="multiselect__single" v-else-if="values.length > 0 && values.length <= 1">{{ values[0].text }}</span>
                                        </template>
                                    </multiselect>
                                    <!-- <div class="requiredstar">*</div> -->
                                    <font class="text-danger">{{otherSiteError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="departmentId">Department :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="departmentId"
                                              @input="changedValueDepartment()"
                                              name="departmentId"
                                              id="departmentId"
                                              label="text"
                                              :options="departmentArr"
                                              :searchable="false"
                                              :filterable="false"
                                              placeholder="Select Department">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{departmentError}}</font>
                                </div>
                            </div>
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span v-model="locationId" class="form-control">{{locationId}}</span>
                                </div>
                            </div>-->
                            <!--Phone-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="phone">Phone :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="phone" type="text" class="form-control" id="phone" placeholder="Phone" maxlength="190">
                                    <font class="text-danger">{{frontendErrors.phoneError}}</font>
                                </div>
                            </div>
                            <!--Post-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="post">Post :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="post" type="text" class="form-control" id="post" placeholder="Post" maxlength="190">
                                    <font class="text-danger">{{frontendErrors.postError}}</font>
                                </div>
                            </div>
                            <!--Team Designation-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="teamdesignation">Team Designation :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="teamDesignation" type="text" class="form-control" id="teamDesignation" placeholder="Team Designation" maxlength="190">
                                    <font class="text-danger">{{frontendErrors.teamDesignationError}}</font>
                                </div>
                            </div>
                            <!--Bio-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="bio">Bio :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="bio" type="text" class="form-control" id="bio" placeholder="Bio" maxlength="190">
                                </div>
                            </div>
                            <!--Role-->
                            <div v-if="loginId != user_id" class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleId">Role :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select class=""
                                              v-model="roleId"
                                              @input="changedRole()"
                                              name="roleId"
                                              id="roleId"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="roleArr"
                                              placeholder="Select Role">
                                    </v-select>
                                    <font class="text-danger">{{frontendErrors.roleId}}</font>
                                </div>
                            </div>
                            <!--Quote-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="quote">Quote :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="quote" type="text" class="form-control" id="quote" placeholder="Quote">
                                </div>
                            </div>

                            <!--Quote Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="phone">Quote Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="quoteName" type="text" class="form-control" id="quoteName" placeholder="Quote Name">
                                </div>
                            </div>

                            <!--Is Allow ERG-->

                            <!-- <div  class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" >Is allow ERG: </div>
                                        </div>
                                    <div class=" col- paddingright0">
                                        <input type="checkbox"  name="allow_erg" id="allow_erg" v-model='allow_erg'>
                                    </div>

                           </div> -->

                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" ></tinymce>
                                    <font class="text-danger">{{frontendErrors.descriptionError}}</font>
                                </div>
                            </div>

                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="allow_social_calendar">Allow Social Media Calendar :</div>
                                    <input type="checkbox" id="allow_social_calendar" name="allow_social_calendar" v-model='allowSocialCalendar'>
                                </div>
                            </div>

                            <template v-if="allowSocialCalendar">

                                <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="allow_review_social_media">Connect & Review Social Media :</div>
                                        <input type="checkbox" id="allow_review_social_media" name="allow_review_social_media" v-model='allowReviewSocialMedia'>
                                    </div>
                                </div>

                                <!-- <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="allow_post_social_media">Post Social Media :</div>
                                        <input type="checkbox" id="allow_post_social_media" name="allow_post_social_media" v-model='allowPostSocialMedia'>
                                    </div>
                                </div> -->

                                <!-- <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="allow_draft_social_media">Draft Social Media :</div>
                                        <input type="checkbox" id="allow_draft_social_media" name="allow_draft_social_media" v-model='allowDraftSocialMedia'>
                                    </div>
                                </div> -->



                            </template>

                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="allow_contact_extension">Allow Contact Extension Directory :</div>
                                    <input type="checkbox" id="allow_contact_extension" name="allow_contact_extension" v-model='allowContactExtension'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="add_location_departments">Can Manage Contact Extension Locations :</div>
                                    <input type="checkbox" id="add_location_departments" name="add_location_departments" v-model='addLocationDepartments'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="allow_user_management">Allow User Management Module :</div>
                                    <input type="checkbox" id="allow_user_management" name="allow_user_management" v-model='allowUserManamentModule'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="allow_forum_module">Allow Forum Module :</div>
                                    <input type="checkbox" id="allow_forum_module" name="allow_forum_module" v-model='allowForumModule'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="allow_manager_tool_box">Allow Manager Tool Box :</div>
                                    <input type="checkbox" id="allow_manager_tool_box" name="allow_manager_tool_box" v-model='allowManagerToolBox'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="show_user_manager_directory">Show User in Manager Directory :</div>
                                    <input type="checkbox" id="show_user_manager_directory" name="show_user_manager_directory" v-model='showUsrManagerDirectory'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="manage_smc_events">Manage Social Media Calendar Event :</div>
                                    <input type="checkbox" id="manage_smc_events" name="manage_smc_events" v-model='manageSMCEvent'>
                                </div>
                            </div>
                            <div v-if="loginId != user_id || roleIdCheck == 0" class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="can_access_manager_directory">Can Access Manager Directory :</div>
                                    <input type="checkbox" id="can_access_manager_directory" name="can_access_manager_directory" v-model='canAccessManagerDirectory'>
                                </div>
                            </div>
                            <div class="col-12 forms-block" id="pro_pic_id">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Profile Picture :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <font class="text-danger"> <strong id="uploadErrorMsg" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <!--Crop Profile Image-->
                            <div class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <vue-croppie
                                        ref="croppieRef"
                                        id="vuecrop"
                                        :viewport="{width:276, height: 312, type: 'square'}"
                                        :boundary="{ width: 286, height: 322 }"
                                        :enableResize="false"
                                        @result="result"
                                        @update="update" ></vue-croppie>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-12 paddingleft0">
                                    <button class="btn-croppie" id="rotateAnti" type="button" @click="rotate(-90)" title="Rotate Left"><i aria-hidden="true" class="fa fa-repeat"></i></button>
                                    <button class="btn-croppie" id="rotateClock" type="button" @click="rotate(90)" title="Rotate Right"><i aria-hidden="true" class="fa fa-undo"></i></button>
                                    <button class="btn-croppie" id="crop" type="button" @click="crop()" title="Crop"><i class="fa fa-crop" aria-hidden="true"></i></button>
                                    <br/>
                                    <img v-bind:src="cropped" width="200"/>
                                    <font class="text-danger">{{cropError}}</font>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input type="submit" value="Save" id="save" class="btn btn-primary" v-on:click.prevent="changeProfile()">
                                    <input type="button" value="Change Password" id="change_password" data-toggle="modal" class="btn btn-primary" data-target="#changePassword" >
                                </div>
                            </div>
                            <!--Model-->
                            <div class="modal fade" id="changePassword" role="dialog">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title">Change Password</h4>
                                            <button type="button" id="changePasswordModel" class="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <!--Old Password-->
                                            <!-- <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="oldPassword">Old Password</label>
                                                    <input class="form-control" id="oldPassword" type="text" placeholder="" name="oldPassword"  v-model="oldPassword" maxlength="190">
                                                    <font class="text-danger">{{frontendErrors.oldPassword}}</font>
                                                </div>
                                            </div>
                                            <div class="clearfix"></div> -->
                                            <!--New Password-->
                                            <div class="col-md-12">
                                                <div class="form-group">    <label for="newPassword">New Password</label>
                                                    <input class="form-control" id="newPassword" type="text" placeholder="" name="newPassword"  v-model="newPassword" maxlength="190">
                                                    <font class="text-danger">{{frontendErrors.newPassword}}</font>
                                                </div>
                                            </div>
                                            <div class="clearfix"></div>
                                            <!--Confirm Password-->
                                            <div class="col-md-12">
                                                <div class="form-group">    <label for="cpassword">Confirm Password</label>
                                                    <input class="form-control" id="cpassword" type="text" placeholder="" name="cpassword"  v-model="cpassword" maxlength="190">
                                                    <font class="text-danger">{{frontendErrors.cpassword}}</font>
                                                </div>
                                            </div>
                                            <div class="clearfix"></div>
                                            <!--Error Alert-->
                                            <div class="row clearfix" >
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div class="alert alert-danger" id="alertError">
                                                        <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
                                                        <strong id="errorMsg" class="error"></strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="clearfix"></div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <button v-on:click.prevent="changePassword()" class="btn btn-primary">Save</button>
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--page content-->
                </form>
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from 'vue';
    import SessioMixin from '../../../mixins/sessionmixin';
    import EventBus from '../../event-bus';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import tinymce from 'vue-tinymce-editor';
    import axios from 'axios';
    import Multiselect from 'vue-multiselect';

    Vue.use(VueCroppie);
    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
            Multiselect
        },
        data() {
            return {
                //DropZone
                dropzoneOptions: {
               // url: "https://httpbin.org/post",
                    url: process.env.ROOT_API + "/uploadmedia",
                    timeout: 3000000,
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 8, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                imageURL: '',
                isDropFileUploaded: false,
                filePath: '',
              //                V-model
                firstName: '',
                lastName: '',
                oldPassword: '',
                newPassword: '',
                cpassword: '',
                user_id: '',
                locationId: '',
                phone: '',
                description: '',
                bio: '',
                quote: '',
                quoteName: '',
                allow_erg:'',
                email: '',
                username: '',
                locationData: '',
                locationArr: [],
                locationIdSearch: '',
                post: '',
                teamDesignation: '',
                imageSize: '',
                id: '',
                siteFirstLoad: 0,
                siteId: '',
                siteArr: [],
                departmentFirstLoad: 0,
                departmentId: '',
                departmentArr: [],

                cropped: null,
                profileImages: [],
                croppedProfileImage: '',
                isCropped: false,
                isFileUploaded: false,
                cropError: '',
                loginId: '',
                roleId: 0,
                roleIdCheck: 0,
                allowSocialCalendar: false,
                allowPostSocialMedia: false,
                allowDraftSocialMedia: false,
                allowReviewSocialMedia: false,
                allowContactExtension: false,
                addLocationDepartments: false,
                allowUserManamentModule: false,
                allowForumModule: false,
                allowManagerToolBox: false,
                roleArr: [],

                // FrontEnd Errors
                frontendErrors: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    oldPassword: '',
                    newPassword: '',
                    cpassword: '',
                    locationError: '',
                    phoneError: '',
                    descriptionError: '',
                    postError: '',
                    teamDesignationError: '',
                    roleId: '',
                    reportToError : '',
                },
                siteError: '',
                departmentError: '',

                //                BackEnd Error
                backendErrors: [],
                reportTo : "",
                reportToArr : [],

                year: '',
                from: '',
                isTalentProfile: false,
                user_id_edit : 0,
                showUsrManagerDirectory : false,
                manageSMCEvent : false,

                otherSiteId: '',
                otherSiteError: '',
                appliedStatusFilter : [],
                canAccessManagerDirectory : false,
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self = this;
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[2] == 'updateusers') {
                self.id = segments[3];
            }
            /*self.loadLocations();*/
            self.loadLocationsAdd();
            self.loadProfile();
            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/
            $("#locationId").on('keyup', function () {
                self.frontendErrors.locationError = '';
            });
            $("#firstName").on('keyup', function () {
                self.frontendErrors.firstName = '';
            });
            $("#lastName").on('keyup', function () {
                self.frontendErrors.lastName = '';
            });
            $("#phone").on('keyup', function () {
                self.frontendErrors.phoneError = '';
            });
            $("#oldPassword").on('keyup', function () {
                self.frontendErrors.oldPassword = '';
            });
            $("#newPassword").on('keyup', function () {
                self.frontendErrors.newPassword = '';
            });
            $("#cpassword").on('keyup', function () {
                self.frontendErrors.cpassword = '';
            });
            $("#password").on('keyup', function () {
                self.frontendErrors.password = '';
            });
            $("#cpassword").on('keyup', function () {
                self.frontendErrors.cpassword = '';
            });
            $("#post").on('keyup', function () {
                self.frontendErrors.postError = '';
            });
            $("#teamDesignation").on('keyup', function () {
                self.frontendErrors.teamDesignationError = '';
            });
            $("#roleId").on('keyup', function () {
                self.frontendErrors.roleId = '';
            });
            $("#email").on('keyup', function () {
                self.frontendErrors.email = '';
            });
            $("#siteId").on('keyup', function () {
                self.siteError = '';
            });
            $("#departmentId").on('keyup', function () {
                self.departmentError = '';
            });
            /*self.loadLocations();*/

            $("#vuecrop").hide();
            $("#rotateAnti").hide();
            $("#rotateClock").hide();
            $("#crop").hide();

            /*self.$refs.croppieRef.bind({
             url: '',
             });*/

            $("#browse").on('change', function () {
                self.readFile(this);
                $("#vuecrop").show();
                $("#rotateAnti").show();
                $("#rotateClock").show();
                $("#crop").show();
            });
            self.loadRole();

            if(this.$route.query.from) {
              var path = window.location.pathname;
              var segments = path.split("/");
              if (segments[2] == 'updateusers') {
                    self.user_id_edit = segments[3];
              }
              self.from = this.$route.query.from;
              self.year = this.$route.query.year;
              self.isTalentProfile = true;
              self.scrollToProfilePic();
            }

        },
        watch: {
            allowPostSocialMedia: function (allowPostSocialMedia) {
              if(allowPostSocialMedia) {
                self.allowDraftSocialMedia = true;
              }

              if(self.allowReviewSocialMedia == true) {
                self.allowDraftSocialMedia = true;
                self.allowPostSocialMedia = true;
                $('#allow_post_social_media').prop('checked', true);
                $('#allow_draft_social_media').prop('checked', true);
              }

            },
            allowDraftSocialMedia: function (allowDraftSocialMedia) {
              if(allowDraftSocialMedia == false && self.allowPostSocialMedia == true) {
                self.allowDraftSocialMedia = true;
                $('#allow_draft_social_media').prop('checked', true);
              }

              if(self.allowReviewSocialMedia == true) {
                self.allowDraftSocialMedia = true;
                self.allowPostSocialMedia = true;
                $('#allow_post_social_media').prop('checked', true);
                $('#allow_draft_social_media').prop('checked', true);
              }

            },
            allowReviewSocialMedia: function (allowReviewSocialMedia) {
              if(allowReviewSocialMedia) {
                self.allowDraftSocialMedia = true;
                self.allowPostSocialMedia = true;
                self.allowReviewSocialMedia = true;
                $('#allow_post_social_media').prop('checked', true);
                $('#allow_draft_social_media').prop('checked', true);
                $('#allow_review_social_media').prop('checked', true);
              }

            },

            locationId: function (locationId) {
                var location = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        location: location
                    }
                };
                HTTP.get("getsite", config)
                        .then(function (response) {
                            self.siteArr = response.data.content;
                            var path = window.location.pathname;
                            var segments = path.split("/");
                            if (segments[2] != 'updateusers' || self.siteFirstLoad > 0) {
                                self.siteId = {
                                    value: response.data.content[0].value,
                                    text: response.data.content[0].text,
                                };
                            }
                            self.siteFirstLoad = 1;
                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            siteId: function (siteId) {
                var site = (self.siteId === null || self.siteId == '') ? 0 : self.siteId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        site: site
                    }
                };
                HTTP.get("getdepartment", config)
                        .then(function (response) {
                            self.departmentArr = response.data.content;
                            var path = window.location.pathname;
                            var segments = path.split("/");
                            if (segments[2] != 'updateusers' || self.departmentFirstLoad > 0) {
                                self.departmentId = {
                                    value: response.data.content[0].value,
                                    text: response.data.content[0].text,
                                };
                            }
                            self.departmentFirstLoad = 1;
                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            otherSiteId : function(){
                self.appliedStatusFilter = [];
                $.each(self.otherSiteId, function (i) {
                    self.appliedStatusFilter.push(self.otherSiteId[i].value);
                });
            },
        },
        methods: {
            scrollToProfilePic: function(){
                $('html, body').animate({
                  scrollTop: $("#pro_pic_id").offset().top
                },1000);
            },
            changedValueUser: function () {
                self.frontendErrors.reportToError = "";
            },
            onSearchUser(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadUsers(loading, search, this);
                }
                /*}*/
            },
            loadUsers(loading, search, vm) {
                let self = this;
                var siteId = "";
                var departmentId = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    search: search,
                    except_self : 1,
                };
                HTTP.post("getusersdropdown", fields,config)
                        .then(function (response) {
                            self.reportToArr = [];
                            $.each(response.data.content, function (i) {
                                self.reportToArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            changedRole: function () {
                self.frontendErrors.roleId = "";
            },
            buttonBack() {
              $(".back_button").prop("disabled", false);
              if(self.isTalentProfile) {
                self.$router.push("/backend/talentprofile?id=" + self.user_id_edit + "&from=9box&year=" + self.year);
              } else {
                self.$router.push('/backend/listusers');
              }

            },
            removedSelectedFile(file, xhr, error) {
                self.isFileUploaded = false;
                self.isDropFileUploaded = false;
                self.isCropped = false;

                /* if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                } */

                var removeFile = "";
                if ("manuallyAdded" in file == true) {
                    if (self.filePath.indexOf(file.name) != -1) {
                        removeFile = self.filePath;
                    }
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                    removeFile = removeFile.media_path
                }

                if (self.filePath === removeFile) {
                    self.imageURL = '';
                    self.imageSize = '';
                    self.filePath = '';
                }
                
                $("#vuecrop").hide();
                $("#rotateAnti").hide();
                $("#rotateClock").hide();
                $("#crop").hide();
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                    // console.log("File removed successfully");
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                self.cropError = '';
                $("#uploadErrorMsg").html('');
                if (self.isDropFileUploaded == false) {
                    self.imageURL = file.dataURL;
                    self.isDropFileUploaded = true;
                    self.isFileUploaded = true;
                    self.$refs.croppieRef.bind({
                        url: self.imageURL,
                    });
                    $("#vuecrop").show();
                    $("#rotateAnti").show();
                    $("#rotateClock").show();
                    $("#crop").show();
                    var filePathJSON = JSON.parse(file.xhr.response);
                    self.filePath = filePathJSON.content.media_path;
                    self.imageSize = file.size;
                } else if (self.isDropFileUploaded == true) {
                    self.removedSelectedFile(file);
                    var err = "You can Upload Only One Image";
                    $("#uploadErrorMsg").html(err);
                }
            },

            changedValue: function (value) {
                //console.log(value);
            },
            changedValueSite: function () {
                self.siteError = "";
            },
            changedValueDepartment: function () {
                self.departmentError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            changedValueLocation: function () {
                self.frontendErrors.locationError = "";
            },

            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            self.locationArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadLocationsAdd(loading, search, vm) {
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            checkPasswordForm: function () {
                var checked = true;
                /* self.frontendErrors.oldPassword = ''; */
                self.frontendErrors.newPassword = '';
                self.frontendErrors.cpassword = '';

                /* if (!self.oldPassword) {
                    self.frontendErrors.oldPassword = 'Old Password Required';
                    if (checked) {
                        checked = false;
                    }
                } */

                if (!self.newPassword) {
                    self.frontendErrors.newPassword = 'New Password Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.newPassword && self.newPassword.length < 6) {
                    self.frontendErrors.newPassword = "New Password Length Longer Than 6";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.cpassword) {
                    self.frontendErrors.cpassword = 'Confirm Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.newPassword != self.cpassword) {
                    self.frontendErrors.cpassword = 'Password Does Not Match';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            changePassword: function () {
                self.checkPasswordForm();
                if (self.checkPasswordForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var fields = {
                        id: self.id,
                        /* oldPassword: self.oldPassword, */
                        newPassword: self.newPassword,
                        confirmpassword: self.cpassword,
                    };
                    self.showLoader();
                    HTTP.post('resetpassword', fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    $("#changePasswordModel").click();
                                    /* self.oldPassword = ''; */
                                    self.newPassword = '';
                                    self.cpassword = '';
                                    self.$swal({
                                        type: 'success',
                                        text: 'Password Changed Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                } else {
                                    $("#alertError").show();

                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] /* + "<br>" */;
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").toggleClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                }
                                self.hideLoader();
                            })
                }

            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.firstName = "";
                self.frontendErrors.lastName = "";
                self.frontendErrors.locationError = "";
                self.frontendErrors.phoneError = "";
                self.cropError = "";
                self.frontendErrors.roleId = "";
                self.frontendErrors.reportToError = "";
                self.frontendErrors.email = '';
                self.otherSiteError = "";

                if (!self.email) {
                    self.frontendErrors.email = 'Please Enter Email';
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.email)) {
                    self.frontendErrors.email = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.firstName) {
                    self.frontendErrors.firstName = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.reportTo == null || !self.reportTo.value) {
                    self.frontendErrors.reportToError = "Reporting To is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.roleId) {
                    self.frontendErrors.roleId = "Role is Required";
                    if (checked) {
                        checked = false;
                    }
                } else {
                    if (self.roleId.value == 1) {
                        if (self.isFileUploaded == false) {
                            self.cropError = 'Please Upload Image';
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.isCropped == false) {
                            self.cropError = 'Please Crop the Image';
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (!self.post) {
                            self.frontendErrors.postError = "Post Required";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (!self.teamDesignation) {
                            self.frontendErrors.teamDesignationError = "Team Designation Required";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                if (!self.lastName) {
                    self.frontendErrors.lastName = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.locationId) {
                    self.frontendErrors.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.siteId) {
                    self.siteError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.departmentId) {
                    self.departmentError = "Department Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.phone && !String(self.phone).match(/^[0-9]*$/)) {
                    self.frontendErrors.phoneError = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phone && String(self.phone).match(/^[0-9]*$/) && self.phone.length < 10) {
                    self.frontendErrors.phoneError = "Phone Number Must Be Of Minimum 10 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phone && String(self.phone).match(/^[0-9]*$/) && self.phone.length > 13) {
                    self.frontendErrors.phoneError = "Phone Number Must Be Of Maximum 13 Digits";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (self.otherSiteId.length == 0) {
                    self.otherSiteError = "Other Location Required";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadProfile: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    var userJson = JSON.parse(userObj);
                    self.loginId = userJson.id;
                }

                  //                if (segments[3] == 0) {
                  //                    var fields = {id: "loginId"};
                  //                } else {
                  //                    var fields = {id: segments[3]};
                  //                }

                if (segments[2] == 'updateusers') {
                    var fields = {id: segments[3]};
                }
                self.showLoader();
                HTTP.post('getregisteruser/' + segments[3], fields, config)
                        //                HTTP.post("getregisteruser", '', config)
                        .then(function (response) {
                            self.user_id = response.data.content[0].id;
                            self.locationId = {
                                value: response.data.content[0].location_id,
                                text: response.data.content[0].location_name,
                            };
                            self.siteId = {
                                value: response.data.content[0].site_id,
                                text: response.data.content[0].site_name,
                            };
                            self.departmentId = {
                                value: response.data.content[0].department_id,
                                text: response.data.content[0].department_name,
                            };
                            self.firstName = response.data.content[0].first_name;
                            self.lastName = response.data.content[0].last_name;
                            self.description = response.data.content[0].description;
                            self.bio = response.data.content[0].bio;
                            self.quote = response.data.content[0].quote;
                            self.quoteName = response.data.content[0].quote_name;
                            // self.allow_erg=response.data.content[0].allow_erg;
                            self.email = response.data.content[0].email;
                            self.phone = response.data.content[0].phone;
                            self.username = response.data.content[0].username;
                            self.filePath = response.data.content[0].profile_image;
                            self.post = response.data.content[0].post;
                            self.teamDesignation = response.data.content[0].team_designation;
                            self.roleIdCheck = response.data.content[0].roles.id;
                            self.roleId = {
                                value: response.data.content[0].roles.id,
                                text: response.data.content[0].roles.name,
                            };
                            if(response.data.content[0].reporting_to_id != null && response.data.content[0].reporting_to_id != 'null' && response.data.content[0].reporting_to_id != ''){
                                self.reportTo = {
                                    value: response.data.content[0].reporting_to_id,
                                    text: response.data.content[0].reporting_to,
                                }
                            }

                            self.otherSiteId = [];
                            if(response.data.content[0].other_location != null && response.data.content[0].other_location.length > 0){
                                for (var i = 0; i < response.data.content[0].other_location.length; i++) {
                                    self.otherSiteId.push(response.data.content[0].other_location[i]);
                                }
                            }

                            $.each(response.data.content[0].permission, function (i) {
                                if (response.data.content[0].permission[i].name == 'access_social_media_calendar') {
                                    self.allowSocialCalendar = true;
                                    self.allowDraftSocialMedia = true;

                                }
                                if (response.data.content[0].permission[i].name == 'review_social_media') {
                                    self.allowReviewSocialMedia = true;
                                }
                                // if (response.data.content[0].permission[i].name == 'draft_social_media') {
                                //     self.allowDraftSocialMedia = true;
                                // }
                                if (response.data.content[0].permission[i].name == 'post_social_media') {
                                    self.allowPostSocialMedia = true;
                                }

                                if (response.data.content[0].permission[i].name == 'add_contact_extension') {
                                    self.allowContactExtension = true;
                                }
                                if (response.data.content[0].permission[i].name == 'add_location_departments') {
                                    self.addLocationDepartments = true;
                                }
                                if (response.data.content[0].permission[i].name == 'allow_user_management_module') {
                                    self.allowUserManamentModule = true;
                                }
                                if (response.data.content[0].permission[i].name == 'allow_forum_module') {
                                    self.allowForumModule = true;
                                }
                                if (response.data.content[0].permission[i].name == 'allow_manager_tool_box') {
                                    self.allowManagerToolBox = true;
                                }
                                if(response.data.content[0].permission[i].name == 'view_user_in_manager_directory') {
                                    self.showUsrManagerDirectory = true;
                                }
                                if(response.data.content[0].permission[i].name == 'can_access_manager_directory') {
                                    self.canAccessManagerDirectory = true;
                                }
                                if(response.data.content[0].permission[i].name == 'manage_social_media_calendar_events') {
                                    self.manageSMCEvent = true;
                                }
                            });
                            //console.log(self.allowSocialCalendar);

                            //self.cropped = response.data.content.profile_image;
                            //console.log(self.filePath);

                            if (self.filePath != '') {
                                self.isFileUploaded = true;
                                self.isDropFileUploaded == true;
                                self.imageSize = response.data.content[0].image_size;
                                self.isCropped = true;
                                self.uploadManually();
                            }

                            //                            if (self.cropped == '') {
                            //                                $("#crop").hide();
                            //                            } else if (self.cropped != '') {
                            //                                self.isFileUploaded = true;
                            //                                self.isCropped = true;
                            //                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            uploadManually(file) {
                if (self.filePath != '') {
                    var file_name = self.getFileName(self.filePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.filePath;
                    let file_size = self.imageSize;
                    //console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            changeProfile() {
                self.checkForm();
                if (self.checkForm()) {
                    let otherLocationArr = [];
                    if(self.otherSiteId.length > 0) {
                        for (let i = 0; i < self.otherSiteId.length; i++) {
                            otherLocationArr.push(self.otherSiteId[i]['value']);
                        }
                    }

                    console.log("In change profile");
                    var path = window.location.pathname;
                    var segments = path.split("/");

                      //                    var userObj = localStorage.getItem("user_obj");
                      //                    if (userObj != null) {
                      //                        var userJson = JSON.parse(userObj);
                      //                        self.loginId = userJson.id;
                      //                    }

                      //                    if (segments[3] == 0) {
                      //                        self.id = self.loginId;
                      //                    } else {
                      //                        self.id = segments[3];
                      //                    }

                    /* if (segments[2] == 'updateusers') {
                        self.id = segments[3];
                    } */

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    $("#save").val("Saving ...");
                    $("#save").prop("disabled", true);
                    // console.log("self.allow_erg"+self.allow_erg);
                    var fields = {
                        id: self.id,
                        email: self.email,
                        first_name: self.firstName,
                        last_name: self.lastName,
                        phone: self.phone,
                        location_id: self.locationId.value,
                        description: self.description,
                        bio: self.bio,
                        quote: self.quote,
                        quote_name: self.quoteName,
                        // allow_erg:self.allow_erg,
                        profile_image: self.croppedProfileImage,
                        filePath: self.filePath,
                        imageSize: self.imageSize,
                        post: self.post,
                        team_designation: self.teamDesignation,
                        role_id: self.roleId.value,
                        site: self.siteId.value,
                        department: self.departmentId.value,
                        allow_social_calendar: self.allowSocialCalendar,
                        post_social_media: self.allowPostSocialMedia,
                        draft_social_media: self.allowDraftSocialMedia,
                        review_social_media: self.allowReviewSocialMedia,
                        allow_contact_extension: self.allowContactExtension,
                        add_location_departments: self.addLocationDepartments,
                        allow_user_management_module: self.allowUserManamentModule,
                        allow_forum_module: self.allowForumModule,
                        allow_manager_tool_box: self.allowManagerToolBox,
                        view_user_manager_directory: self.showUsrManagerDirectory,
                        manage_smc_events: self.manageSMCEvent,
                        report_to : self.reportTo.value,
                        otherLocationIdArr : otherLocationArr,
                        can_access_manager_directory : self.canAccessManagerDirectory
                    };
                    self.showLoader();
                    HTTP.post("changeprofile", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    window.localStorage.setItem("profile_image", response.data.profile_image);
                                    var userObj = localStorage.getItem("user_obj");
                                    if (userObj != null) {
                                        var userJson = JSON.parse(userObj);
                                        self.loginID = userJson.id;
                                      //                                    EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"], localStorage.getItem("profile_image"));
                                    }
                                    $("#save").val("Save");
                                    $("#save").prop("disabled", false);
                                    self.$swal({
                                        type: 'success',
                                        text: 'User Updated Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    $(".back_button").prop("disabled", true);
                                    setTimeout(function () {
                                        self.buttonBack();
                                    }, 5000);
                                } else {
                                    $("#save").val("Save");
                                    $("#save").prop("disabled", false);
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                $("#save").val("Save");
                                $("#save").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            /*,
             getUser() {
             var getUserdata = {
             'access_token': window.localStorage.getItem('access_token')
             };
             //var access_token = window.localStorage.getItem('access_token');
             axios.post(process.env.ROOT_API + "/user", {
             headers: getUserdata
             })
             .then(function(resp) {
             self.flash(resp.data, 'success', {
             timeout: 3000
             });
             })
             .catch(function(resp) {
             console.log('getUser catch');
             console.log(resp);
             });
             }*/

            // CALBACK USAGE
            crop() {
                // Here we are getting the result via callback function
                // and set the result to this.cropped which is being
                // used to display the result above.
                self.isCropped = true;
                let options = {
                    format: 'jpeg',
                    circle: false,
                }
                self.$refs.croppieRef.result(options, (output) => {
                    self.cropped = output;
                    self.croppedProfileImage = self.cropped;
                    self.cropError = "";
                });
            },
            // EVENT USAGE
            result(output) {
                self.cropped = output;
            },
            update(val) {
                //console.log(val);
            },
            rotate(rotationAngle) {
                // Rotates the image
                self.$refs.croppieRef.rotate(rotationAngle);
            }
        }

    }
              //    EventBus.$on('logged-in', function (isLogin, fname, lname, email, profile_image) {
              //        self.isShowLoggedinfields = isLogin;
              //        self.firstName = fname;
              //        self.lastName = lname;
              //        self.email = email;
              //        self.profile_image = (profile_image != '') ? profile_image : '/static/images/default.jpg';
              //    });
</script>

<style>
    /*.disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }*/
</style>



// WEBPACK FOOTER //
// src/components/backend/user/AddUpdateUsers.vue